import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getFlatMeterStatuses = async () => {
  return await request.get(
    `/Meter/individual_meter_statuses`,
    {},
    'При загрузке статусов счетчика произошла ошибка'
  );
};

const useFlatMeterStatuses = (options) =>
  useQuery(getQueryKeys.flatMeterStatuses(), getFlatMeterStatuses, options);

export default useFlatMeterStatuses;
